export default {
  title: 'NonLinear Folio v1',
  author: {
    name: 'Non-Linear',
    link: 'https://www.non-linear.studio/',
  },
  header: null,
  body: document.body,
  page: null,
  sizes: {
    vw: 0,
    vh: 0,
    h: 0,
  },
  orientation: null,
  sniff: null,
  breakpoints: null,
  flags: {
    smooth: true,
    locked: true,
    resize: false,
  },
  loader: {
    items: [],
    ready: false,
  },
  msgs: {
    rotate: null,
  },
  scroll: {
    current: 0,
    target: 0,
    sticky: 0
  }
}
